import { put, select } from "redux-saga/effects";
import { cloneDeep } from "lodash";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import leadsSelectors from "rdx/modules/leads/selectors";
import platformSelectors from "rdx/modules/platform/selectors";
import entProjectsSelectors from "rdx/modules/enterpriseProjects/selectors";
import { orgProjectsApi } from "rdx/modules/enterpriseProjects/endpoints";
import { ORG_PROJECTS_TAGS } from "rdx/modules/enterpriseProjects/tags";
import { camelizeKeys } from "lib/helpers";
import actions from "rdx/actions";
import messages from "../messages";

function* submitLeadToProvider(action) {
  const { leadId, enterprise, admin, isLeadGen = false } = action.payload;
  if (!leadId) {
    throw new Error(`Invalid lead ID = ${leadId} specified. Please check this parameter.`);
  }
  const { success, data, error } = yield* makeRequest.post(`/provider_leads/${leadId}/qualify`, {
    lead_id: leadId,
    enterprise,
    admin,
  });

  if (success && data) {
    if (isLeadGen && enterprise) {
      const leadGenPreSalesProjects = yield select(entProjectsSelectors.getLeadGenPreSalesProjects);
      const { projects, paging } = cloneDeep(leadGenPreSalesProjects);
      const leadIdx = projects.findIndex((lead) => lead.id.split("_")[0] === data.body.lead.id.toString());

      projects[leadIdx] = {
        ...projects[leadIdx],
        id: data.body.id,
        projectStageName: data.body.stage,
        projectStageMilestoneName: data.body.milestone,
      };

      yield put(actions.setLeadGenPreSalesProjects({ paging, projects }));
    }
    const existingLeadDetails = yield select(leadsSelectors.getLeadDetails);
    const l2pLeadId = yield select(platformSelectors.selectLeadToProposalDrawerLeadId);
    const providerLead = camelizeKeys(data.body);
    if (l2pLeadId === leadId) {
      yield put(actions.setLeadToProposalDrawerProjectId({ id: data.body.id }));
      yield put(actions.setLeadToProposalDrawerProjectDetails(providerLead));
      yield put(actions.setLeadToProposalDrawerLeadQualified());
    }
    if (existingLeadDetails?.id === leadId) {
      yield put(actions.setProjectDetails({ providerLead }));
      yield put(actions.setLeadSubmitted());
    }
    yield put(orgProjectsApi.util.invalidateTags([ORG_PROJECTS_TAGS.ORG_PRE_SALES_PROJECTS]));
    yield put(actions.updatePreSalesProject(formatPreSalesProject(providerLead)));
    if (admin && existingLeadDetails?.id === leadId) {
      yield put(actions.setAdminProjectDetails(providerLead));
    }

    yield put(
      actions.newSuccessEvent({
        message: messages.LEAD_SUBMIT_SUCCESS,
        payload: data.body,
      }),
    );
  } else {
    return getErrorActions({ error, message: messages.ERROR_SUBMITTING_LEAD });
  }
  return null;
}

const formatPreSalesProject = (projectDetails) => {
  const {
    id,
    upcomingStageNames,
    projectProgress,
    soloProposalNonrequestableReason,
    visionProposalNonrequestableReason,
    lightreachProposalNonrequestableReason,
    auroraNonRequestableReason,
    milestone,
  } = projectDetails;
  const milestoneDisplayName = projectProgress.at(-1);

  return {
    projectId: id,
    upcomingStageNames,
    passedStageNames: projectProgress,
    soloProposalNonrequestableReason,
    auroraNonRequestableReason,
    visionProposalNonrequestableReason,
    lightreachProposalNonrequestableReason,
    milestoneDisplayName,
    milestone,
  };
};

export default submitLeadToProvider;
